/* tslint:disable */
import {
  ScreenLayout,
  RotationItem
} from '../index';

declare var Object: any;
export interface LayoutPanelInterface {
  "id": string;
  "top": number;
  "left": number;
  "bottom": number;
  "right": number;
  "height": number;
  "width": number;
  "name"?: string;
  "screenLayoutId"?: string;
  "createdByIp"?: string;
  "lastUpdatedByIp"?: string;
  "createdAt": Date;
  "updatedAt": Date;
  screenLayout?: ScreenLayout;
  rotationItems?: RotationItem[];
  rotationItemsForOverlay?: RotationItem[];
}

export class LayoutPanel implements LayoutPanelInterface {
  "id": string;
  "top": number;
  "left": number;
  "bottom": number;
  "right": number;
  "height": number;
  "width": number;
  "name": string;
  "screenLayoutId": string;
  "createdByIp": string;
  "lastUpdatedByIp": string;
  "createdAt": Date;
  "updatedAt": Date;
  screenLayout: ScreenLayout;
  rotationItems: RotationItem[];
  rotationItemsForOverlay: RotationItem[];
  constructor(data?: LayoutPanelInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `LayoutPanel`.
   */
  public static getModelName() {
    return "LayoutPanel";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of LayoutPanel for dynamic purposes.
  **/
  public static factory(data: LayoutPanelInterface): LayoutPanel{
    return new LayoutPanel(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'LayoutPanel',
      plural: 'LayoutPanels',
      path: 'LayoutPanels',
      idName: 'id',
      properties: {
        "id": {
          name: 'id',
          type: 'string'
        },
        "top": {
          name: 'top',
          type: 'number',
          default: 0
        },
        "left": {
          name: 'left',
          type: 'number',
          default: 0
        },
        "bottom": {
          name: 'bottom',
          type: 'number',
          default: 0
        },
        "right": {
          name: 'right',
          type: 'number',
          default: 0
        },
        "height": {
          name: 'height',
          type: 'number',
          default: 1080
        },
        "width": {
          name: 'width',
          type: 'number',
          default: 1920
        },
        "name": {
          name: 'name',
          type: 'string'
        },
        "screenLayoutId": {
          name: 'screenLayoutId',
          type: 'string'
        },
        "createdByIp": {
          name: 'createdByIp',
          type: 'string'
        },
        "lastUpdatedByIp": {
          name: 'lastUpdatedByIp',
          type: 'string'
        },
        "createdAt": {
          name: 'createdAt',
          type: 'Date'
        },
        "updatedAt": {
          name: 'updatedAt',
          type: 'Date'
        },
      },
      relations: {
        screenLayout: {
          name: 'screenLayout',
          type: 'ScreenLayout',
          model: 'ScreenLayout',
          relationType: 'belongsTo',
                  keyFrom: 'screenLayoutId',
          keyTo: 'id'
        },
        rotationItems: {
          name: 'rotationItems',
          type: 'RotationItem[]',
          model: 'RotationItem',
          relationType: 'hasMany',
                  keyFrom: 'id',
          keyTo: 'layoutPanelId'
        },
        rotationItemsForOverlay: {
          name: 'rotationItemsForOverlay',
          type: 'RotationItem[]',
          model: 'RotationItem',
          relationType: 'hasMany',
                  keyFrom: 'id',
          keyTo: 'layoutPanelOverlayId'
        },
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/sdk/models/LayoutPanel.ts